import React, { useContext } from 'react'
import {
    Grid,
    InputLabel,
    Select,
    useTheme,
    useMediaQuery,
    Typography,
    makeStyles,
} from '@material-ui/core';
import { taxData } from '../../core/calculatorData';
import { StyledFormControl } from '../common/CustomComponents'
import { StudentLoanContext } from './StudentLoanComponent'
import { getTaxYearIndex, getCurrentTaxYearIndex } from '../../core/calculatorUtils';


const useStyles = makeStyles(theme => {
    return {
        active: {
            width:'100%',

            '& .MuiSelect-root': {
            backgroundColor: theme.palette.primary.main,
            },

            '& .MuiInputLabel-root': {
                color: theme.palette.primary.contrastText,
                fontWeight: 700,
            },
            '& .MuiSelect-underline:before, .MuiFilledInput-underline:before': {
                borderColor: theme.palette.primary.light,
            },
        },
        inactive: {
            width:'100%',
        },
    }
});

export const StudentLoanInputOptions = () => {
    const theme = useTheme();
    const classes = useStyles()
    const small = useMediaQuery(theme.breakpoints.down('xs'));
    const { year, setCurrentYear, dataCategories, category, setCategory } = useContext(StudentLoanContext);
    const currentCategories = dataCategories.find(c => c.year === year);
    const taxDataForYear = taxData.find(c=> c.year === year)
    const estimate = taxDataForYear && taxDataForYear.help && taxDataForYear.help.estimate === "true"

    const yearIndex = getTaxYearIndex(year);
    const yearIndexCurrent = getCurrentTaxYearIndex();

    const handleChangeYear = () => event => {
        setCurrentYear(event.target.value)
    }

    const handleChangeCategory = () => event => {
        setCategory(event.target.value)
    }

    return (
        <Grid container spacing={small ? 1 : 4} >
            <Grid item xs={7} md={8}>
                <StyledFormControl variant="filled" fullWidth >
                    <InputLabel htmlFor="payCycle">Loan Type</InputLabel>
                    <Select
                        native
                        variant="filled"
                        id="taxCategory_studentLoan"
                        aria-label="Student loan type"
                        onChange={handleChangeCategory()}
                        value={category}
                    >
                        {currentCategories.categories.map((option, index) => (
                            <option
                                key={`${option} ${index}`}
                                data={option}
                            >
                                {option}
                            </option>
                        ))}
                    </Select>
                </StyledFormControl>


            </Grid>
            <Grid item xs={5} md={4}>
                <StyledFormControl variant="filled" fullWidth className = {yearIndex === yearIndexCurrent ? classes.inactive : classes.active}>
                    <InputLabel htmlFor="taxYearStudentLoan"  >Tax year</InputLabel>
                    <Select
                        native
                        variant="filled"
                        id="taxYearStudentLoan"
                        onChange={handleChangeYear()}
                        aria-label="Select Tax year"
                        value={year}
                    >
                        {dataCategories.map((option, index) => (
                            <option
                                key={option.year + " " + index}
                                data={option.year}
                                value={option.year}
                            >
                                {`${option.year - 1} - ${Number(option.year) - 2000}`}
                            </option>
                        ))}
                    </Select>
                </StyledFormControl>
                {estimate && (
                    <Typography variant="body2">These figures are estimates</Typography>
                    )}
            </Grid>
        </Grid>

    )
}


